import { Spine } from '../spine';
import { Container } from '../pixiContainer';
import { iconStates } from '../../constants/symbolsNames';

export const iconStateAnimations = {
  [iconStates.win]: 'win',
  [iconStates.idle]: 'idle',
  [iconStates.blur]: 'blur',
  [iconStates.noWin]: 'noWin',
  [iconStates.wild1]: 'wild1',
  [iconStates.wild2]: 'wild2',
  [iconStates.wild3]: 'wild3',
  [iconStates.idleBig1]: 'idleBig1',
  [iconStates.idleBig2]: 'idleBig2',
  [iconStates.idleBig3]: 'idleBig3',
};

export class SlotIcon extends Container {
  constructor(options) {
    super(options);
    const styles = { origin: 0.5, roundPixels: false };
    this.winParent = options.winParent;
    this.index = options.index;
    this.reelIndex = options.reelIndex;
    this.xPosition = options.xPosition;
    this.spinParent = this.parent;
    this.icon = this.addChild(
      new Spine({
        elementId: `${this.elementId}_Icon`,
        key: '4',
        styles,
      })
    );
    this.iconNumber = null;
    this.loop = false;
    this.currentState = null;
    this.changeState(iconStates.idle);
    this.roundPixels = false;
    this.children.forEach((c) => {
      c.roundPixels = false;
    });
  }

  changeIcon(newNumber, state = iconStates.idle) {
    if (newNumber === this.iconNumber) return;
    this.iconNumber = newNumber;
    this.icon.show();
    this.icon.changeTexture(this.iconNumber.toString());
    this.changeState(state);
  }

  changeState(state) {
    this.currentState = state;
    this.icon.stop();
    this.changeToActualParent();
    if (this.icon) {
      this.icon.play(
        iconStateAnimations[state],
        state === iconStates.win || state === iconStates.idle
      );
      this.icon.clearListeners();
      return new Promise((res) => {
        this.icon.addListener('complete', res);
      });
    }
    return false;
  }

  addOnCompleteHandler(handler, context = null, once = false) {
    if (this.icon) {
      this.icon.addListener('complete', handler, context);
      const spine = this.icon;
      return () => {
        spine.removeListener('complete', handler, context);
      };
    }
    const hh = this.icon.loop ? 'onLoop' : 'onComplete';
    const a = once
      ? () => {
          handler.call(context);
          this.icon[hh] = null;
        }
      : () => {
          handler.call(context);
        };
    this.icon[hh] = a;
    return () => {
      this.icon[hh] = null;
    };
  }

  changeToActualParent() {
    let parent;
    if (this.currentState === iconStates.win) parent = this.winParent;
    else parent = this.spinParent;
    if (parent !== this.parent) parent.addChild(this);
  }
}

export function getIconValueFromIconNumber(iconNumber) {
  return Number(iconNumber.toString().split('-')[1] || 0);
}
